<template>
  <div class="admin-layout">
    <aside class="sidebar">
      <router-link class="sidebar-brand" :to="{ name: 'bdManagement' }" :aria-label="$t('admin.home')">
        <img src="@/assets/rainchat-img/rainchat.png" alt="RainChat" />
        <!-- <span>管理后台</span> -->
      </router-link>

      <nav class="menu" :aria-label="$t('admin.navigation')">
        <router-link
          v-for="item in menu"
          :key="item.key"
          class="menu-item"
          :to="{ name: item.routeName }"
        >
          <span class="menu-icon">{{ item.icon }}</span>
          <span>{{ $t(item.labelKey) }}</span>
        </router-link>
      </nav>
    </aside>

    <div v-if="mobileMenuOpen" class="mobile-menu-mask" @click="closeMobileMenu">
      <aside class="mobile-sidebar" @click.stop>
        <div class="mobile-sidebar-header">
          <span>{{ $t('admin.backend') }}</span>
          <button type="button" :aria-label="$t('admin.closeMenu')" @click="closeMobileMenu">×</button>
        </div>
        <nav class="mobile-menu" :aria-label="$t('admin.navigation')">
          <router-link
            v-for="item in menu"
            :key="item.key"
            class="mobile-menu-item"
            :to="{ name: item.routeName }"
            @click.native="closeMobileMenu"
          >
            <span class="menu-icon">{{ item.icon }}</span>
            <span>{{ $t(item.labelKey) }}</span>
          </router-link>
        </nav>
      </aside>
    </div>

    <div class="main-area">
      <header class="topbar">
        <div class="topbar-title">
          <p class="breadcrumb">{{ $t('admin.backend') }} / {{ currentTitle }}</p>
          <div class="title-row">
            <h1>{{ currentTitle }}</h1>
            <button class="mobile-menu-trigger" type="button" :aria-label="$t('admin.openMenu')" @click="openMobileMenu">
              ☰
            </button>
          </div>
        </div>
        <el-dropdown trigger="click" @command="handleCommand">
          <button class="user-trigger" type="button">
            <span class="avatar">
              <img v-if="user.avatar" class="avatar-img" :src="user.avatar" alt="" />
              <template v-else>{{ user.avatarText || "R" }}</template>
            </span>
            <span class="user-info"><strong>{{ displayName }}</strong><small>ID: {{ user.id }} · {{ displayRole }}</small></span>
            <span class="caret">⌄</span>
          </button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">{{ $t('admin.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </header>

      <main class="page-content" :class="{ 'page-content--bd': $route.name === 'bdManagement' }"><router-view /></main>
    </div>
  </div>
</template>

<script>
import { Dropdown, DropdownItem, DropdownMenu } from "element-ui";
import { ADMIN_MENU } from "../admin.config";

export default {
  name: "AdminLayout",
  components: { ElDropdown: Dropdown, ElDropdownItem: DropdownItem, ElDropdownMenu: DropdownMenu },
  data() {
    return {
      mobileMenuOpen: false,
    };
  },
  computed: {
    user() { return this.$store.state.admin.user || {}; },
    userRoles() {
      if (Array.isArray(this.user.roles)) return this.user.roles;
      const legacyRole = this.user.role || "";
      return [
        legacyRole.includes("BDM") && "BDM",
        legacyRole.includes("BD") && "BD",
        (legacyRole.includes("公会长") || legacyRole.includes("公会管理员")) && "公会长",
      ].filter(Boolean);
    },
    menu() {
      return ADMIN_MENU.filter((item) => item.roles.some((role) => this.userRoles.includes(role)));
    },
    currentTitle() {
      const item = ADMIN_MENU.find((entry) => entry.routeName === this.$route.name);
      return item ? this.$t(item.labelKey) : this.$t("admin.backend");
    },
    displayName() { return this.user.name || this.$t("admin.userFallback", { id: this.user.id }); },
    displayRole() {
      const roleKeys = { BDM: "bdm", BD: "bd", "公会长": "leader" };
      const roles = this.userRoles.map((role) => roleKeys[role]).filter(Boolean);
      return roles.length ? roles.map((role) => this.$t(`admin.roles.${role}`)).join(" · ") : this.$t("admin.roles.admin");
    },
  },
  methods: {
    openMobileMenu() {
      this.mobileMenuOpen = true;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    },
    handleCommand(command) {
      if (command !== "logout") return;
      this.$store.commit("admin/clearUser");
      this.$router.replace({ name: "adminLogin" });
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-layout { display: flex; min-height: 100vh; color: #344563; background: #f3f6ff; font-family: Arial, "Microsoft YaHei", sans-serif; }
.sidebar { flex: 0 0 10.7vw; min-height: 100vh; background: #fff; box-shadow: .05vw 0 .4vw rgba(40, 57, 100, .05); }
.sidebar-brand { display: flex; align-items: center; gap: .5vw; height: 3.75vw; padding: 0 1.25vw; border-bottom: 1px solid #edf0f6; color: #33496d; font-size: .78vw; font-weight: 600; text-decoration: none; }.sidebar-brand img { width: 4.7vw; height: auto; }
.menu { padding: 1.05vw .5vw; }.menu-item { display: flex; align-items: center; gap: .5vw; height: 2.4vw; margin-bottom: .4vw; padding: 0 .72vw; border-radius: .52vw; color: #687c9a; font-size: .73vw; text-decoration: none; }.menu-item.router-link-active { color: #536dff; background: linear-gradient(90deg, #edf0ff, #f6f2ff); font-weight: 600; }.menu-icon { display: grid; width: 1.25vw; height: 1.25vw; place-items: center; border-radius: .35vw; color: #697cff; background: #eef1ff; font-size: .52vw; font-weight: 700; }
.main-area { flex: 1; min-width: 0; }.topbar { display: flex; align-items: center; justify-content: space-between; height: 3.75vw; padding: 0 1.45vw; border-bottom: 1px solid #e7ebf4; background: #fff; }.breadcrumb { margin: 0 0 .15vw; color: #a0acc0; font-size: .62vw; }.title-row { display: flex; align-items: center; }.topbar h1 { margin: 0; color: #263c5f; font-size: .94vw; font-weight: 600; }.user-trigger { display: flex; align-items: center; gap: .47vw; border: 0; background: transparent; color: #2b3f61; cursor: pointer; font: inherit; text-align: left; }.avatar { display: grid; flex: 0 0 32px; width: 32px; height: 32px; place-items: center; overflow: hidden; border-radius: 50%; color: #fff; background: linear-gradient(135deg, #5f83ff, #7259fb); font-size: 13px; font-weight: 600; }.avatar-img { width: 100%; height: 100%; object-fit: cover; }.user-info strong, .user-info small { display: block; line-height: 1.35; }.user-info strong { font-size: .68vw; }.user-info small { color: #9cabc1; font-size: .57vw; }.caret { color: #8c9bb1; font-size: .83vw; }.page-content { padding: 1.25vw 1.45vw; }.page-content--bd { padding-bottom: 0; }
.mobile-menu-mask, .mobile-menu-trigger { display: none; }
@media screen and (max-width: 900px) { .sidebar { display: none; }.topbar { height: 58px; padding: 0 18px; }.topbar h1 { font-size: 17px; }.user-info { display: none; }.page-content { padding: 18px; }.page-content--bd { padding-bottom: 0; }.mobile-menu-trigger { display: block; margin-left: 10px; padding: 4px 8px; border: 0; color: #536dff; background: transparent; font-size: 24px; line-height: 1; cursor: pointer; }.mobile-menu-mask { position: fixed; z-index: 1000; inset: 0; display: block; background: rgba(25, 37, 62, 0.38); }.mobile-sidebar { width: min(78vw, 280px); min-height: 100%; background: #fff; box-shadow: 4px 0 18px rgba(25, 37, 62, 0.18); }.mobile-sidebar-header { display: flex; align-items: center; justify-content: space-between; height: 58px; padding: 0 18px; border-bottom: 1px solid #edf0f6; color: #33496d; font-size: 17px; font-weight: 600; }.mobile-sidebar-header button { border: 0; color: #8c9bb1; background: transparent; font-size: 28px; line-height: 1; cursor: pointer; }.mobile-menu { padding: 12px 10px; }.mobile-menu-item { display: flex; align-items: center; gap: 10px; height: 48px; padding: 0 12px; border-radius: 10px; color: #687c9a; font-size: 15px; text-decoration: none; }.mobile-menu-item.router-link-active { color: #536dff; background: linear-gradient(90deg, #edf0ff, #f6f2ff); font-weight: 600; }.mobile-menu-item .menu-icon { width: 26px; height: 26px; font-size: 12px; } }
@media screen and (min-width: 901px) {
  .sidebar { flex-basis: 200px; }
  .sidebar-brand { gap: 10px; height: 64px; padding: 0 20px; }
  .sidebar-brand img { width: 88px; }
  .menu { padding: 14px 10px; }
  .menu-item { gap: 10px; height: 42px; margin-bottom: 8px; padding: 0 12px; border-radius: 10px; }
  .menu-icon { width: 24px; height: 24px; border-radius: 7px; }
  .topbar { height: 64px; padding: 0 28px; }
  .page-content { padding: 20px 28px; }
  .page-content--bd { padding-bottom: 0; }
  .sidebar-brand { font-size: 14px; }
  .menu-item { font-size: 13px; }
  .menu-icon { font-size: 10px; }
  .breadcrumb { font-size: 12px; }
  .topbar h1 { font-size: 18px; }
  .user-info strong { font-size: 13px; }
  .user-info small { font-size: 11px; }
  .caret { font-size: 16px; }
}
</style>
